import type { DeepReadonly } from 'vue'
import type { Deck } from '@/entities/deck'
import type { Hotspot } from '@/entities/site'

export function useEndpointNavigation() {
  const config = useRuntimeConfig()

  async function goToDeck(deck: DeepReadonly<Deck> | Readonly<Deck> | Deck) {
    //TODO: Remove once the deck is implemented
    location.href = `${config.public.WEB_ENDPOINT}decks/${deck.id}`

    // return navigateTo({
    //   name: 'decks-deckId',
    //   params: {
    //     deckId: deck.id,
    //   },
    // })
  }

  async function goToProject(project: { id: number; sites: Hotspot[] }) {
    const primarySite = project.sites.find(site => site.is_primary) || project.sites[0]
    return navigateTo({
      name: 'projects-projectId-sites-siteId',
      params: {
        projectId: project.id.toString(),
        siteId: primarySite.id.toString(),
      },
    })
  }

  return { goToDeck, goToProject }
}
